/**
 * Central cache tag constants used for fetch caching and revalidation.
 */
export const CacheTags = {
  Product: 'product',
  Cart: 'cart',
  Post: 'post',
  // Add more as needed
};

export type CacheTag = (typeof CacheTags)[keyof typeof CacheTags];
